import { render, staticRenderFns } from "./TrafficRequestRecommendationTemplate.vue?vue&type=template&id=37d8c81f&scoped=true"
import script from "./TrafficRequestRecommendationTemplate.vue?vue&type=script&lang=ts"
export * from "./TrafficRequestRecommendationTemplate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d8c81f",
  null
  
)

export default component.exports